<template>
	<div style="height: 100%;width: 100%;">
		<div class="Topline">
			<div class="linein">
				<div class="Innerbox">
					<el-progress type="circle" :percentage="20" :width="160"></el-progress>
				</div>
			</div>
			<div class="linein">
				<div class="Innerbox">
					<el-progress type="circle" :percentage="30" :width="160"></el-progress>
				</div>
			</div>
			<div class="linein">
				<div class="Innerbox">
					<el-progress type="circle" :percentage="80" :width="160"></el-progress>
				</div>
			</div>
			<div class="linein">
				<div class="Innerbox">
					<el-progress type="circle" :percentage="40" :width="160"></el-progress>
				</div>
			</div>
		</div>
		<div class="ChartBox"></div>
		<div class="ChartBox"></div>
		<div class="ChartBox"></div>
		<div class="ChartBox"></div>
	</div>
</template>

<script>
	export default {
		data (){
			return {
				token:"",
			}
		},
		methods:{
			
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
		}
	}
</script>

<style scoped>

.Topline {
	margin-top: 10px;
	width: 100%;
	height: 160px;
	display: flex;
	display: -webkit-flex;
	flex-direction: row;
	justify-content:space-between
	
}
.linein {
	width: 23%;
	height: 100%;
	background: white;
	box-shadow: 0px 2px 25px #D9D9D9;
	border: 2px solid #fff;
}
.Innerbox {
	width: 160px;
	height: auto;
	margin: 0 auto;
}
.linein:hover,.ChartBox:hover {
	border: 2px solid #3ad1c5;
	box-shadow:none
}

.ChartBox {
	width: 100%;
	height: 300px;
	box-shadow: 0px 2px 25px #D9D9D9;
	border: 2px solid #fff;
	margin-top: 20px;
}

</style>


// WEBPACK FOOTER //
// PortraitForUser.vue?f63edb08